import React from "react";
import { Button, Form, Card, Spinner, Alert } from "react-bootstrap";
import { store } from "../../reducer/Store";
import Utils from "../../services/Utils";
import { ToastContainer } from "react-toastify";
import ApiService from "../../services/ApiService";
import "../../styles/_home.scss";

const PdfExport = () => {
  const { state } = React.useContext(store);
  const [listDr, setListDr] = React.useState([]);
  const [isCustomers, setIsCustomers] = React.useState(false);
  const [noResultMessage, setNoResultMessage] = React.useState(false);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [suggestions, setSuggestions] = React.useState([]);
  const [loader, setLoader] = React.useState(false);
  const [loaderSearchVr, setLoaderSearchVr] = React.useState(false);
  const useremail = JSON.parse(localStorage.getItem("user"));
  const [selectedInterlocutor, setSelectedInterlocutor] = React.useState({
    id: "",
    name: "",
    customer_ids: [],
    role: "",
  });
  /**
   * Gère le changement de valeur dans la liste des interlocuteurs DR.
   * La fonction handleOnChangeDr est utilisée pour gérer le changement de valeur dans la liste des interlocuteurs DR. Elle prend en paramètre e,
   * l'événement de changement de valeur dans la liste des interlocuteurs DR.
   * Filtre les interlocuteurs DR dans listDr pour obtenir celui correspondant à la valeur sélectionnée (e.target.value).
   * Construit le nom du DR en concaténant le prénom et le nom du DR avec des traits de soulignement à la place des espaces.
   * Met à jour selectedInterlocutor avec les informations du DR sélectionné, y compris l'identifiant, le nom du DR, les identifiants des clients et le rôle "DR".
   * Si le DR sélectionné existe (drCustomers.length > 0) et n'a pas d'identifiants de clients (drCustomers[0].customer_ids.length === 0), défini isCustomers sur true. Sinon, défini isCustomers sur false.
   * @param {*} e - L'événement de changement de valeur dans la liste des interlocuteurs DR.
   */
  const handleOnChangeDr = (e) => {
    let drCustomers = listDr.filter((dr) => dr.id === parseInt(e.target.value));
    let drname =
      drCustomers.length > 0
        ? drCustomers[0].firstname + "_" + drCustomers[0].lastname
        : "";
    setSelectedInterlocutor({
      id: e.target.value,
      name: drname.replaceAll(" ", "_"),
      customer_ids: drCustomers[0].customer_ids,
      role: "DR",
    });
    if (drCustomers.length > 0 && drCustomers[0].customer_ids.length === 0) {
      setIsCustomers(true);
    } else {
      setIsCustomers(false);
    }
  };

  /**
   * Gère le changement de valeur dans la liste des suggestions d'interlocuteurs VR.
   * La fonction handleOnChangeVr est utilisée pour gérer le changement de valeur dans la liste des suggestions d'interlocuteurs VR.
   * Elle prend en paramètre suggestion, la suggestion sélectionnée.
   * Met à jour la valeur de searchQuery en concaténant le prénom et le nom de la suggestion.
   * Construit le nom du VR en utilisant le prénom et le nom de la suggestion avec des traits de soulignement à la place des espaces.
   * Met à jour selectedInterlocutor avec les informations de la suggestion, y compris l'identifiant, le nom du VR, les identifiants des clients et le rôle "VRP".
   * Si la suggestion n'a pas d'identifiants de clients (suggestion.customer_ids.length === 0), défini isCustomers sur true. Sinon, défini isCustomers sur false.
   * Réinitialise suggestions à un tableau vide.
   * @param {*} suggestion
   */
  const handleOnChangeVr = (suggestion) => {
    setSearchQuery(`${suggestion.firstname} - ${suggestion.lastname}`);
    const vrName = `${suggestion.firstname}_${suggestion.lastname}`;
    setSelectedInterlocutor({
      id: suggestion.id,
      name: vrName.replaceAll(" ", "_"),
      customer_ids: suggestion.customer_ids,
      role: "VRP",
    });
    if (suggestion.customer_ids.length === 0) {
      setIsCustomers(true);
    } else {
      setIsCustomers(false);
    }
    setSuggestions([]);
  };
  /**
   * Prend le premier dr de la liste le met en défaut
   * @param {*} drList  la liste des Dr de la requête
   */
  const setDefaultDr = (drList) => {
    if (drList.length > 0) {
      let drname = drList[0].firstname + "_" + drList[0].lastname;
      setSelectedInterlocutor({
        id: drList[0].id,
        name: drname.replaceAll(" ", "_"),
        customer_ids: drList[0].customer_ids,
        role: "DR",
      });
    }
  };

  /**
   * Elle parcourt chaque élément du tableau d'origine et extrait les identifiants des clients.
   * Si les identifiants sont déjà un tableau, le premier élément est ajouté à la liste des identifiants.
   * Sinon, si les identifiants sont un objet, chaque valeur de l'objet est ajoutée à la liste des identifiants.
   * @param {*} array
   * @returns {*} array
   */

  const createArrayOfCustomerids = (array) => {
    let result = [];
    let responseArray = Object.values(array);
    if (responseArray.length > 0) {
      responseArray.forEach((element, i) => {
        let customerIdList = [];
        let customer_ids = element.customer_ids;
        if (Array.isArray(customer_ids)) {
          customerIdList.push(parseInt(customer_ids[0]));
        } else {
          for (const property in customer_ids) {
            customerIdList.push(parseInt(customer_ids[property]));
          }
        }
        result.push({
          firstname: element.firstname,
          lastname: element.lastname,
          customer_ids: customerIdList,
          id: i + 1,
        });
      });
    }
    return result;
  };

  /**
   * La fonction handleSubmit est appelée lors de la soumission du click sur  Générer les Pdf.
   * Elle prend deux paramètres : e (l'événement de soumission) et selectedInterlocutor (l'interlocuteur sélectionné).
   * Définit isCustomers sur false. Empêche le comportement par défaut du formulaire.
   *  Définit loader sur false.
   * Construit l'objet data avec les données nécessaires pour la demande API.
   * Effectue une requête API POST vers 'download-pdf' en utilisant les données fournies.
   * Si la requête réussit, affiche une notification en cours de progression et enregistre la réponse dans la console.
   * Si la requête échoue, arrête le chargement, affiche une notification d'erreur et enregistre l'erreur dans la console.
   *
   * @param {*} e
   * @param {*} selectedInterlocutor
   */
  const handleSubmit = (e, selectedInterlocutor) => {
    setIsCustomers(false);
    e.preventDefault();
    setLoader(false);
    const data = {
      dr_id: parseInt(selectedInterlocutor.id),
      dr_name: Utils.replaceAccent(selectedInterlocutor.name),
      dr_customer_ids: selectedInterlocutor.customer_ids,
      year_id: parseInt(state.currentYear.value),
      brand_id: parseInt(
        state.currentBrands.length > 0 ? state.currentBrands[0].value : ""
      ),
      year_name: state.currentYear.label,
      brand_name: Utils.replaceAccent(state.currentBrands[0].label),
      user_email: useremail[1],
      role: selectedInterlocutor.role,
    };
    ApiService.request(data, "download-pdf", "post")
      .then(function (response) {
        Utils.notifyInProgress(
          "Votre demande peut prendre plusieurs minutes Une fois finalisée, vous recevrez par mail un lien pour télécharger les rapports Merci de patienter."
        );
        //  Utils.notifySuccess('Le mail a été envoyé');
        setLoader(false);
        //console.log(response);
      })
      .catch(function (error) {
        setLoader(false);
        console.log(error);
        Utils.notifyError("de la génération des pdf en lot.");
      });
  };
  /**
   * Cette fonction est utilisée pour récupérer et mettre à jour les interlocuteurs DR.
   * Appelé lors de l'appel du composant
   * Définit isCustomers sur false.
   * Définit loader sur true pour indiquer que le chargement est en cours.
   * Réinitialise selectedInterlocutor avec des valeurs vides.
   * Effectue une requête API GET en utilisant ApiService.request pour récupérer les interlocuteurs DR.
   * L'URL de l'API est construite en fonction des valeurs de state.currentBrands et state.currentYear.
   * Si la requête réussit, elle obtient les interlocuteurs DR de la réponse et crée un tableau d'objets contenant les identifiants des clients à l'aide de createArrayOfCustomerids.
   * Elle met à jour les états listDr et defaultDr avec ce tableau, puis arrête le chargement en définissant loader sur false.
   * Si la requête échoue, elle réinitialise listDr, affiche une notification d'erreur et enregistre l'erreur dans la console.
   *  Enfin, elle arrête le chargement en définissant loader sur false.
   */
  const getInterlocutorsDr = () => {
    setIsCustomers(false);
    setLoader(true);
    setSelectedInterlocutor({
      id: "",
      name: "",
      customer_ids: "",
      role: "",
    });
    ApiService.request(
      {},
      `interlocutors-dr-by-brand-year/${
        state.currentBrands.length > 0 ? state.currentBrands[0].value : ""
      }/ ${state.currentYear.value}`,
      "get"
    )
      .then(function (response) {
        //  console.log(response)
        const getAllDr = response.data;
        //console.log(getAllDr)
        //console.log(createArrayOfCustomerids(getAllDr));
        setListDr(createArrayOfCustomerids(getAllDr));
        setDefaultDr(createArrayOfCustomerids(getAllDr));

        setLoader(false);
      })
      .catch(function (error) {
        setListDr([]);
        Utils.notifyError("l'affichage de la liste des suivis.");
        console.log(error);
        setLoader(false);
      });
  };

  /**
   * La fonction getInterlocutorsVr est utilisée pour récupérer les interlocuteurs VR en fonction de la recherche effectuée.
   * Elle prend en paramètre e, l'événement de changement de valeur dans la barre de recherche.
   * Met à jour la valeur de searchQuery avec la valeur de la recherche.
   * Si la longueur de la recherche est supérieure ou égale à 3, elle effectue les actions suivantes :
   * Définit loaderSearchVr sur true pour indiquer que le chargement est en cours.
   * Réinitialise noResultMessage à false.
   * Effectue une requête API POST en utilisant ApiService.request pour récupérer les interlocuteurs VR. Les paramètres de la requête incluent l'identifiant de l'année en cours,
   * l'identifiant de la marque en cours et la valeur de la recherche en minuscules.
   * Si la requête réussit, elle vérifie si la réponse indique qu'il n'y a pas de résultat (response.message === "No result.").
   * Dans ce cas, elle définit noResultMessage sur true. Sinon, elle récupère les interlocuteurs VR de la réponse et les met à jour dans suggestions.
   * Arrête le chargement en définissant loaderSearchVr sur false.
   * la longueur de la recherche est égale à 0, elle effectue les actions suivantes :
   * Réinitialise suggestions à un tableau vide.
   * Réinitialise noResultMessage à false.
   * Réinitialise selectedInterlocutor avec des valeurs vides.
   *  @param {*} e - L'événement de changement de valeur dans la barre de recherche.
   */
  const getInterlocutorsVr = (e) => {
    setSearchQuery(e.target.value);

    if (e.target.value.length >= 2) {
      setLoaderSearchVr(true);
      setNoResultMessage(false);
      ApiService.request(
        {
          year_id: parseInt(state.currentYear.value),
          brand_id: parseInt(
            state.currentBrands.length > 0 ? state.currentBrands[0].value : ""
          ),
          search: e.target.value.toLowerCase(),
        },
        "interlocutors-vr-by-brand-year",
        "post"
      )
        .then(function (response) {
          console.log(response, "response");
          setLoaderSearchVr(false);
          if (response.message === "No result.") {
            setNoResultMessage(true);
          } else {
            const custosmers = response.data;
            setSuggestions(custosmers);
          }
        })
        .catch(function (error) {
          Utils.notifyError("l'affichage de la liste des suivis.");
          console.log(error);
          setSuggestions([]);
          setLoaderSearchVr(false);
        });
    } else if (e.target.value.length === 0) {
      setSuggestions([]);
      setNoResultMessage(false);
      setSelectedInterlocutor({
        id: "",
        name: "",
        customer_ids: "",
        role: "",
      });
    }
  };

  const getVrpDataByUserID = () => {
    ApiService.request(
      {
        year_id: parseInt(state.currentYear.value),
        brand_id: parseInt(
          state.currentBrands.length > 0 ? state.currentBrands[0].value : ""
        ),
        user_id: JSON.parse(localStorage.getItem("userId")),
      },
      "interlocutors-vr-by-brand-year-user",
      "post"
    )
      .then(function (response) {
        handleOnChangeVr(response.data[0]);
      })
      .catch(function (error) {
        Utils.notifyError("l'affichage de la liste des suivis.");
        console.log(error);
        setSuggestions([]);
        setLoaderSearchVr(false);
      });
  };

  React.useEffect(() => {
    if (state.currentBrands.length > 0 && state.currentBrands.length === 1) {
      if (parseInt(localStorage.getItem("user_role")) === 6) {
        getVrpDataByUserID();
      } else {
        getInterlocutorsDr();
      }
    }
  }, [state.currentBrands.length, state.currentYear.value]);

  return (
    <>
      {state.currentBrands.length === 0 ||
      state.currentBrands.length > 1 ||
      parseInt(localStorage.getItem("user_role")) === 6 ? (
        ""
      ) : (
        <Card className="mb-10">
          <Card.Body>
            <Card.Title className="title">
              Sélectionner un directeur régional{" "}
            </Card.Title>
            <form onSubmit={(e) => handleSubmit(e, selectedInterlocutor)}>
              {!loader ? (
                <>
                  <div className="row">
                    <Form.Group className="col-5" controlId={`select-${""}`}>
                      <Form.Select
                        onChange={(e) => handleOnChangeDr(e)}
                        required
                        value={selectedInterlocutor.id}
                        name="customerPlv"
                      >
                        {/*  <option>  </option> */}
                        {listDr.length > 0 &&
                          listDr.map((data, i) => (
                            <option value={data.id} key={i}>
                              {data.firstname + "  " + data.lastname}
                            </option>
                          ))}
                        {listDr.length === 0 ? (
                          <option> Aucun DR Touvé</option>
                        ) : (
                          ""
                        )}
                      </Form.Select>
                    </Form.Group>
                  </div>
                  <Button
                    disabled={
                      isCustomers ||
                      listDr.length === 0 ||
                      selectedInterlocutor.customer_ids.length === 0
                        ? true
                        : false
                    }
                    type="submit"
                  >
                    Générer les Pdf
                  </Button>
                </>
              ) : (
                <div className="text-center pt-5">
                  <Spinner
                    animation={loader ? "border" : false}
                    role="status"
                  ></Spinner>
                </div>
              )}
            </form>
          </Card.Body>
        </Card>
      )}
      {state.currentBrands.length === 0 ||
      state.currentBrands.length > 1 ||
      parseInt(localStorage.getItem("user_role")) === 6 ? (
        ""
      ) : (
        <Card className="mt-4">
          <Card.Body>
            <Card.Title className="title">
              Rechercher un VRP par nom ou prenom
            </Card.Title>
            <form onSubmit={(e) => handleSubmit(e, selectedInterlocutor)}>
              {
                <>
                  <div className="row">
                    <Form.Group className="col-5">
                      <Form.Control
                        type="text"
                        className="search"
                        placeholder={"Rechercher ..."}
                        autoFocus
                        required
                        value={searchQuery}
                        onChange={(e) => getInterlocutorsVr(e)}
                      />
                      {!loaderSearchVr ? (
                        <>
                          {!noResultMessage ? (
                            suggestions.length > 0 && (
                              <ul className="list-group search-bar-vr-pdf">
                                {suggestions.map((suggestion, i) => (
                                  <li
                                    key={i}
                                    className="list-group-item"
                                    onClick={() => handleOnChangeVr(suggestion)}
                                  >
                                    {`${suggestion.firstname} - ${suggestion.lastname}`}
                                  </li>
                                ))}
                              </ul>
                            )
                          ) : (
                            <ul className="list-group">
                              <li className="list-group-item">
                                Aucun resultat
                              </li>
                            </ul>
                          )}
                        </>
                      ) : (
                        <div className="text-center pt-5">
                          <Spinner
                            animation={loaderSearchVr ? "border" : false}
                            role="status"
                          ></Spinner>
                        </div>
                      )}
                    </Form.Group>
                  </div>
                  <Button
                    disabled={
                      isCustomers ||
                      selectedInterlocutor.customer_ids.length === 0
                        ? true
                        : false
                    }
                    type="submit"
                  >
                    Générer les Pdf
                  </Button>
                </>
              }
            </form>
          </Card.Body>
        </Card>
      )}
      {state.currentBrands.length === 0 ||
      state.currentBrands.length > 1 ||
      parseInt(localStorage.getItem("user_role")) !== 6 ? (
        ""
      ) : (
        <Card className="mt-4">
          <Card.Body>
            <Card.Title className="title">Télécharger Pdf</Card.Title>
            <form onSubmit={(e) => handleSubmit(e, selectedInterlocutor)}>
              {
                <>
                  <div className="row">
                    <Form.Group className="col-5"></Form.Group>
                  </div>
                  <Button
                    disabled={
                      isCustomers ||
                      selectedInterlocutor.customer_ids.length === 0
                        ? true
                        : false
                    }
                    type="submit"
                  >
                    Générer ses Pdf en tant que VRP
                  </Button>
                </>
              }
            </form>
          </Card.Body>
        </Card>
      )}
      {state.currentBrands.length === 0 || state.currentBrands.length > 1 ? (
        <Card className="text-center">
          <Card.Body>
            <Alert variant="danger" className="m-0">
              Veuillez sélectionner une seule marque pour exporter le rapport.
            </Alert>
          </Card.Body>
        </Card>
      ) : (
        ""
      )}

      {isCustomers ? (
        <Card className="text-center mt-5">
          <Card.Body>
            <Alert variant="danger" className="m-0">
              Aucun rapport disponible pour ce {selectedInterlocutor.role}
            </Alert>
          </Card.Body>
        </Card>
      ) : (
        ""
      )}
      <ToastContainer />
    </>
  );
};

export default PdfExport;
